import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import { ROOT_DIR, LOCATION, DOMAIN } from '../../utils/Constants';
import BackLink from '../pieces/BackLink';
import GeneralUtil from '../../utils/GeneralUtil';
import SmallLoader from '../pieces/SmallLoader';
import GoogleAd from '../pieces/GoogleAd';

/* global google */

const style = {
  display: 'block'
}

function Address({...props}){
  return (
     props.addr ?
      props.addr.map((item, idx) => (
          <div key={idx}>{item.long_name}</div>
        ))
      
      :
      ''
  )
}
function Hours({...props}){
  return (
    props.hours ?
      props.hours.map((item, idx) => (
          <div className="day" key={idx}>{item}</div>
        ))
    :
    ''
  )
}
function Photos({...props}){
  //console.log(props);
  return (
    
     props.photos ?
       <div>
        <div className="row">
          <div className="large-12 columns">
            <div className="bold details-heading">
              PHOTOS
            </div>
          </div>
        </div>
        <div className="row photos-wrapper">
        {props.photos.map((item, idx) => (

            <div key={idx} className={`medium-4 large-3 columns img-wrapper ${idx + 1 === props.photos.length ? ' end' : ''}`}>
                <img src={item.getUrl({maxHeight: 200, maxWidth: 500})} alt="" onError={BusinessDetail.handleError} />
            </div>
          ))}
        </div>
      </div>
      :
      ''
  )
}

class BusinessDetail extends Component {
  state = {
    place: {}
  }
  componentDidMount(){
    window.scrollTo(500, 0);
    // Connect the initMap() function within this class to the global window context,
        // so Google Maps can invoke it
        window.initMap = this.initMap;
        // Asynchronously load the Google Maps script, passing in the callback reference
        
        loadJS(`https://maps.googleapis.com/maps/api/js?key=AIzaSyDCgXBG7quJEvH9qMqEhbl7JNc1QBEB69E&libraries=places&callback=initMap`);
        if(!this.props.typeDir){
          this.props.getTypeFromDir(this.props.match.params.dir);
        }
        
        
  }
  
  initMap = () => {

      var map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 51.523420, lng: 0.581568},
        zoom: 15
        // styles:[
        //     { featureType: "water", stylers: [ { hue: "#F4B741"} ] },
        //     { featureType: "road", stylers: [ { hue: "#ff0000" } ] }
        // ]
      });
      var infowindow = new google.maps.InfoWindow();
      var service = new google.maps.places.PlacesService(map);

      service.getDetails({
        placeId: this.props.match.params.id
      }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          

          var marker = new google.maps.Marker({
            map: map,
            position: place.geometry.location
          });
          // console.log(place);
          map.setCenter(place.geometry.location);

          google.maps.event.addListener(marker, 'click', function() {
            infowindow.setContent('<div><strong>' + place.name + '</strong><br>' + 
              place.formatted_address + '</div>');
            infowindow.open(map, this);
          });
          this.setState({
            place: place
          });
        }
      });
      
  }
  handleError = () => {
    console.log('image error');
  }
  render(){
    
    let title = '';
    let place = this.state.place;
    let prevPage = '/';
    if(this.props.typeDir){
      title = GeneralUtil.renderName(this.props.match.params.dir);
      prevPage = '/businesses/' + this.props.match.params.dir;
    }
    else {
      if(place.types){
        title = GeneralUtil.renderName(place.types[0]);
        prevPage = '/search/' + this.props.match.params.dir;
      }
      
    }

    const meta = {
      title: `― ${place.name}, ${title} in ${LOCATION}, Essex ― find businesses, services, events and more in ${LOCATION}, Essex, UK in our business directory`,
      description: `${place.name}, ${title} in ${LOCATION}. Find ${title}, businesses, services, events and more in ${LOCATION}, Essex, UK. Business directory for ${LOCATION}, Essex`,
      canonical: `http://www.${DOMAIN}/details/${this.props.match.params.dir}/${this.props.match.params.id}`,
      meta: {
        keywords: `${place.name}, ${title} in ${LOCATION}, Essex, ${LOCATION}, Essex, online, ${LOCATION} businesses, ${LOCATION} business directory, ${LOCATION} services, ${LOCATION} events, UK, United Kingdom`
      }
      
    };
    
    return(
      <div>
        <DocumentMeta {...meta} />
        <div ref="map" className="map-wrapper" id="map">
          <SmallLoader/>
        </div>
        


        <div className="row company-name-wrapper">
          <div className="large-12 columns company-name-col">
            <p className="text-xsmall g-map-link"><i className="fa fa-google" aria-hidden="true"></i> <a href={place.url} target="_blank"> View in Google Maps</a></p>
            <h2 className="company-name no-margin">{place.name}</h2>
            <div className="company-subheading">{title} on {LOCATION}</div>
          </div>
        </div>
        <div className="page-content-wrapper innerpage-details">
          <div className="row innerpage-contact-hours">
            <div className="medium-6 columns">
              <div className="innerpage-details-section">
                <div className="bold details-heading"><i className="fa fa-map-marker" aria-hidden="true"></i> ADDRESS</div>
                <Address addr={place.address_components}/>
              </div>
              { place.formatted_phone_number ? 
                <div className="innerpage-details-section">
                  <div className="bold details-heading"><i className="fa fa-phone" aria-hidden="true"></i> TEL</div>
                  <div>Phone: <a href={`tel:${place.formatted_phone_number}`} className="tel">{place.formatted_phone_number}</a></div>
                </div>
              :
              ''
              }
              
              { place.website ? 
                <div className="innerpage-details-section">
                  <div className="bold details-heading"><i className="fa fa-globe" aria-hidden="true"></i> WEBSITE</div>
                  <div><a href={place.website} target="_blank">{place.website}</a></div>

                  
                </div>
              :
              ''
              }
              
            </div>

            <div className="medium-6 columns">
              <div className="innerpage-details-section">
                <div className="bold details-heading hours-heading">HOURS</div>
                {place.opening_hours && place.opening_hours.open_now ? 
                  <img className="open-icon" src={`${ROOT_DIR}/assets/img/open.png`} alt=""/>
                :
                ''
                }
                {place.opening_hours && place.opening_hours.weekday_text ? 
                  <Hours hours={place.opening_hours.weekday_text}/>
                :
                  <p>No opening hours information available.</p>
                }
                
              </div>
            </div>

          </div>
          <Photos photos={place.photos}/>
          
          <div className="row">
            <div className="large-12 columns">
              <GoogleAd 
                client="ca-pub-3501112787403549" 
                slot="9802299641" 
                format="auto" 
                wrapperDivStyle={style}
              />
            </div>
          </div>

          <BackLink
            prevPage={prevPage}
          />

          
        </div>
      </div>
    );
  }
}
function loadJS(src) {
    var ref = window.document.getElementById('gtmgr');
    var script = window.document.createElement("script");
    script.src = src;
    script.async = true;
    ref.parentNode.insertBefore(script, ref);
}
export default BusinessDetail;


// WEBPACK FOOTER //
// ./src/components/pages/BusinessDetail.js